module.exports = __webpack_public_path__ + "static/media/insomnicat.d0fbb758.jpg";